import React from 'react';

import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as ReloadIcon } from 'assets/general/icons/Reload.svg';

import { Field, FieldProps } from 'react-final-form';

import {
  Color,
  ColorPickerProps,
  ColorPicker as MuiColorPicker,
  createColor,
} from 'material-ui-color';

const useStyles = makeStyles((theme) => ({
  input: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& div': {
      width: '100%',
    },
  },
  label: {
    fontSize: 12,
    color: '#969AB2',
  },
  reloadIcon: {
    cursor: 'pointer',
  },
}));

interface IInputProps {
  inputProps?: Partial<ColorPickerProps>;
  defaultValue?: string;
}

const ColorPicker = ({
  name,
  disabled,
  label,
  onFocus,
  helperText,
  defaultValue,
  ...rest
}: FieldProps<any, any> & IInputProps) => {
  const classes = useStyles();

  return (
    <Field
      name={name}
      render={({ input: { name, onChange, value }, meta: { touched, error } }) => {
        const isError = !!(touched && error);

        const handleChange = (newValue: Color) => {
          if (typeof newValue === 'string') {
            onChange(newValue);
          } else {
            if (typeof newValue.raw === 'string') {
              onChange(`${newValue.raw}`);
            } else {
              onChange(`#${newValue.hex}`);
            }
          }
        };

        const handleReset = () => {
          onChange(defaultValue);
        };

        const colorValue = typeof value === 'string' ? createColor(value) : value;

        return (
          <Box>
            <InputLabel className={classes.label}>{label}</InputLabel>

            <Box className={classes.input}>
              <MuiColorPicker value={colorValue} onChange={handleChange} disablePlainColor />
              {defaultValue && <ReloadIcon onClick={handleReset} className={classes.reloadIcon} />}
            </Box>
            {isError && <FormHelperText error>{error}</FormHelperText>}
          </Box>
        );
      }}
      {...rest}
    />
  );
};

export default ColorPicker;
